module.exports = __webpack_public_path__ + "static/media/IoT-扩展转接.2e197d6e.jpg";